import getEnvironment from 'utils/getEnvironment';

const env = getEnvironment();

let mapAPiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY_DEV;
if (env === 'production') {
  mapAPiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY_PROD;
} else if (env === 'test') {
  mapAPiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY_TEST;
}

const ChargerOnMap = ({
  cpid,
  longitude,
  latitude,
  mapHeight = 350,
  mapWidth = 450,
  zoomLevel = 20,
}) => {
  return (
    <div style={{ border: '1px solid #dadada' }}>
      {' '}
      <img
        alt="example"
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoomLevel}&size=${mapWidth}x${mapHeight}&maptype=roadmap
  &markers=${encodeURIComponent(
    `color:0x3A72B3|label:C|${latitude},${longitude}`,
  )}&key=${mapAPiKey}`}
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default ChargerOnMap;
